import { Address, AddressCreateParams } from '@brenger/api-client';
import { getHouseNumberIncludingSuffixFromLine1 } from '@brenger/utils';

export const getAddressLabel = (address: Address): string => {
  const line1 = address.line1 || '';
  const locality = address.locality || '';
  const postalCode = address.postal_code || '';
  const fullAddress = `${line1} ${locality} ${postalCode}`.trim();
  return !fullAddress ? 'Invalid Address' : fullAddress;
};

export const parseLine1Line2 = (a: AddressCreateParams, isDutchLayout: boolean): AddressCreateParams => {
  if (!isDutchLayout) {
    // no parsing needed, because there is only line 1
    return a;
  }
  // dutch addresses need parsing because the fields are separate in the UI, but saved together when sent to core
  const { line1, ...exisiting } = a;
  const line2FromLine1 = getHouseNumberIncludingSuffixFromLine1(line1);
  const newLine1 = line2FromLine1 ? line1?.replace(line2FromLine1, '').trim() : line1;
  return {
    ...exisiting,
    line1: newLine1,
    line2: line2FromLine1 || exisiting.line2,
  };
};
